import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy, ViewChild } from "@angular/core";
import { StoreService } from '../../../../services/store.service'
import { MessageService } from "../../../../services/message.service";
import { MasterService } from "../../../../services/master.service";
import { SecurityService } from '../../../../services/security.service'
import { ActivatedRoute } from "@angular/router";
import * as languageLibrary from '../../../../services/language'
import { Subject, Subscription } from 'rxjs';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { INVENTORY } from '../../../../constants/inventory'
import { SAVE_DEBOUNCE_MILLIS, SALE_TYPES } from "src/app/constants/sale";
import { formatCount } from "src/app/utils/format";
import { clean } from "src/app/utils/numeric";
import { SaleStage } from "src/app/models/sale-stage.model";
import { OdometerType } from "src/app/models/odometer-type.model";
import { Purchase } from "src/app/models/purchase.model";
import { Inventory } from "src/app/models/inventory.model";
import { SEARCH_DEBOUNCE_MILLIS } from "src/app/constants/list";
import { TradeInComponent } from "./components/trade-in/trade-in.component";

@Component({
    selector: "stock",
    templateUrl: "./stock.component.html",
    styleUrls: ["./stock.component.scss"],
    standalone: false
})

export class DealStockComponent implements OnInit, OnChanges, OnDestroy {

    @Input() lienholders: Object[] = []
    
    @Input() salePrice = 0
    
    @Input() isLocked: boolean = false
    
    @Input() saleId: number = 0
    
    @Input() isQuote: boolean = true

    //
    @Input() saleType = null

    @ViewChild(TradeInComponent) tradeInComponent: TradeInComponent;

    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    protected words = languageLibrary.language
    
    protected auxVehicle = {}
    
    protected saleStages: SaleStage[] = []
    
    protected vinLookup = ''
    
    protected saleVehicle = null
    
    protected saleVehicles = []
    
    protected saleVehicleId = 0
    
    protected isEdit = false
    
    protected isAdmin = false

    // Indicates a vehicle is currently being traded
    protected trading: boolean = false

    protected odometers: OdometerType[] = INVENTORY.ODOMETER_TYPES
    
    readonly RETAIL_TRANS_TYPE = 'Retail'
    
    private saleVehicleTransactionTypes = []
    
    protected formRetailVehicle: FormGroup;
    
    protected inventoryListFilters = '&statuses=Available'
    
    protected displayList: boolean = false
    
    protected inventoryId = 0

    protected lotId: number = 0
    
    protected buyerId: number = 0

    // A list of past purchases for the selected buyer. 
    // Allows the selection of one of these past purchases as a trade-in
    protected purchases: Array<Purchase> = null

    //  An associative array of sale types with the id as the key
    protected saleTypes: Record<number, string> = SALE_TYPES

    protected loading: boolean = false
    protected saving: boolean = false
    protected finding: boolean = false

    protected findVehicle: FormGroup

    protected matchedVehicles: Inventory[] = []

    // A debounce timer for search events. Used to wait for 
    // the user to stop typing before we fetch.
    private watcher: ReturnType<typeof setTimeout> = null

    /** Listen for component events and make decisions. */
    private componentWatcher: Subscription | null = null

    private subscriptions: Subscription[] = []

    get wholesale(): boolean { return ((this.saleType) && (this.saleTypes[this.saleType] === 'Wholesale')) }
    get formControlRetailVehicle() {
        return this.formRetailVehicle.controls;
    }
    get tradeCount(): number {
        return this.tradeInComponent?.tradeCount || 0
    }

    constructor(private ms: MessageService, private master: MasterService, private route: ActivatedRoute, private store: StoreService, public security: SecurityService, private fb: FormBuilder) {
        this.findVehicle = this.fb.group({
            inquiry: new FormControl<string>('', [])
        })
    }

    ngOnInit() {
        this.saleId = 0
        const id = parseInt(this.route.snapshot.params['id'])
        if (id && !isNaN(id) && (id > 0)) {
            this.saleId = id
        }
        
        this.lotId = parseInt(localStorage.getItem('lot'))

        this.formRetailVehicle = this.fb.group({
            mileage: [0, [Validators.required, Validators.min(0)]],
            odometerStatus: [{ value: 'actual', disabled: this.isLocked }, Validators.required],
        })

        this.subscriptions.push(
            this.formRetailVehicle.valueChanges.subscribe(() => {
                if (this.watcher) {
                    clearTimeout(this.watcher)
                }
                
                this.watcher = setTimeout(() => {
                    this.save()
                }, SAVE_DEBOUNCE_MILLIS)
            })
        )

        this.subscriptions.push(
            this.findVehicle.get('inquiry').valueChanges.subscribe(inquiry => {
                if (this.watcher) {
                    clearTimeout(this.watcher)
                    this.watcher = null
                }

                const found = this.matchedVehicles.find((item) => `${item.stock} ${item.year} ${item.make} ${item.model}` === inquiry)
                if (found) {
                    this.vehicleSelected(found.id)
                    return
                }

                this.watcher = setTimeout(() => {
                    this.findAVehicle()
                }, SEARCH_DEBOUNCE_MILLIS)
            })
        )

        this.componentWatcher = this.ms.channelComponents$.subscribe((event) => {
            if (!event || !event.message) {
                return
            }

            switch (event.message) {
                case 'saleCreated':
                    this.saleCreated(event.value)
                    break
                case 'buyerRead':
                case 'buyerAdded':
                case 'buyerChanged':
                    if (this.buyerId == event.value.id) {
                        break
                    }

                    this.buyerId = parseInt(event.value.id)
                    this.fetchBuyerPastPurchases()
                    break
                case 'tradeChanged':
                    this.trading = false
                    this.fetchBuyerPastPurchases()
                    break
            }
        })

        this.populate()
        // this.setActiveTab(null, 'sale-vehicle')
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.isLocked && this.formRetailVehicle) {
            this.formRetailVehicle.enable({emitEvent: false})
            if (this.isLocked) {
                this.formRetailVehicle.disable({emitEvent: false})
            }
            return
        }
    }

    ngOnDestroy() {
        for (const sub of this.subscriptions) {
            sub.unsubscribe()
        }
        if (this.componentWatcher) {
            this.componentWatcher.unsubscribe()
        }
        if (this.watcher) {
            clearTimeout(this.watcher)
        }
    }

    // listener childrens
    public listenerChildrens = (e): void => {
        switch (e.message) {
            // Retail vehicle selected from inventory
            case 'choseVehicle':
                this.closeChooser()
                this.vehicleSelected(e.inventoryId)
                break
        }
    }

    /**
     * 
     * @param e 
     * @param activeTab 
     */
    protected setActiveTab = (e: Event | null, activeTab: string) => {
        if (e) {
            e.stopPropagation()
            e.preventDefault()
        }

        const links: NodeListOf<HTMLAnchorElement> = document.querySelectorAll<HTMLAnchorElement>('#stock-tabs.nav-tabs > .nav-item > a.nav-link')
        links.forEach((link) => {
            link.classList.remove('active')
        })

        const tabs: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>('#stock-tab-content.tab-content > section.tab-pane')
        tabs.forEach((tab) => {
            tab.classList.remove('active')
            tab.classList.remove('show')
        })

        const tabLink: HTMLAnchorElement = document.getElementById(`${activeTab}-link`) as HTMLAnchorElement
        if (tabLink) {
            tabLink.classList.add('active')
        }

        const tab: HTMLElement = document.getElementById(`${activeTab}-tab`) as HTMLElement
        if (tab) {
            tab.classList.add('active')
            tab.classList.add('show')
        }
    }

    /**
     * Acquire the data needed for the view
     */
    private populate = async () => {
        await this.master.getAsync(`sales/vehicletransactiontypes`).then(res => {
            this.saleVehicleTransactionTypes = res.data.VehicleTransactionTypes ? res.data.VehicleTransactionTypes.slice() : []
        })

        await this.master.getAsync(`collections/sales/stages`).then(res => {
            this.saleStages = res.data.Stages ? res.data.Stages.slice() : []
        })

        if (this.saleId <= 0) {
            return
        }

        this.saleVehicles = await this.getSaleVehicles()
        if (!this.saleVehicles || (this.saleVehicles.length <= 0)) {
            return
        }

        this.saleVehicle = this.saleVehicles[0]
        if (!this.saleVehicle || !this.saleVehicle['inventory']) {
            return
        }

        this.saleVehicleId = this.saleVehicle['inventory']['id'] ? parseInt(this.saleVehicle['inventory']['id']) : 0
        this.vinLookup = this.saleVehicle['inventory']['stockNumber']
        this.formRetailVehicle.controls['mileage'].setValue(formatCount(this.saleVehicle['mileage']), {emitEvent: false});
        this.formRetailVehicle.controls['odometerStatus'].setValue((this.saleVehicle['odometerStatus'] || 'actual').toLowerCase(), {emitEvent: false});
        
        // need this here since other components depend on it (terms)
        const payload = {
            id: parseInt(this.saleVehicle['id']),
            inventoryId: this.saleVehicleId,
            year: parseInt(this.saleVehicle['inventory']['vehicle']['modelYear']),
            make: this.saleVehicle['inventory']['vehicle']['make'],
            model: this.saleVehicle['inventory']['vehicle']['model'],
            miles: parseInt(this.saleVehicle['mileage']),
            price: parseFloat(this.saleVehicle['inventory']['sellingPrice'])
        }

        this.ms.channelComponents$.emit({message: 'vehicleRead', section: 'stock', value: payload})
    }
    
    /**
     * Acquire the vehicles selected on the sale
     */
    private getSaleVehicles = async () => {
        if (!this.saleId || (this.saleId <= 0)) {
            return
        }

        this.loading = true
        return await this.master.getAsync(`sales/${this.saleId}/vehicles?type=retail`).then((res) => {
            this.loading = false
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            return res.data.vehicles;
        })
    }

    /**
     * Acquire inventory list
     */
    public findAVehicle = (): void => {
        if (this.security.notPermitted('inventory', 'inventory list', 'view')) {
            return
        }

        if (this.finding) { // already getting next page?
            return
        }

        if (this.lotId == 0){
            return
        }

        this.matchedVehicles = []
        const inquiry = this.findVehicle.get('inquiry').value
        if (!inquiry || (inquiry.length <= 0)) {
            return
        }

        const inquiryParam = `&q=${encodeURIComponent(inquiry)}`
        this.finding = true

        this.master.get(`inventory?lotId=${this.lotId}&page=1&statuses=available${inquiryParam}`, (res) => {
            this.finding = false

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.matchedVehicles = res.data.inventory
        })
    }

    public tradeNew = (e: Event): void => {
        if (!e) {
            return
        }

        e.stopPropagation()
        
        this.ms.channelComponents$.emit({message: 'addTrade', section: 'stock', value: null})
    }

    /**
     * A past vehicle purchase of the buyer was selected as a trade-in on this sale.
     * @param e The event that trigger the purchase selection
     * @param inventoryId Unique internal identity of the invenotry item to be traded-in on this sale.
     */
    public tradeSelected = (e: Event, inventoryId: number): void => {
        if (!e) {
            return
        }

        e.stopPropagation()

        if (!inventoryId || (inventoryId <= 0)) {
            return
        }

        this.trading = true

        // hide the dropdown menu
        const body = document.querySelector('body') as HTMLElement
        if (body) {
            body.click()
        }

        this.ms.channelComponents$.emit({message: 'pastPurchaseTraded', section: 'stock', value: inventoryId})
        this.trading = false
    }

    /**
     * Assign the selected vehicle
     * @param { Number } inventoryId The id of the selected inventory item.
     */
    public vehicleSelected = async (inventoryId) => {
        if (inventoryId <= 0) {
            return
        }

        const inventoryItem: Inventory = await this.fetchInventoryItem(inventoryId)
        if (!inventoryItem || !inventoryItem['stockNumber']) {
            return
        }

        const vehicleTransType = this.saleVehicleTransactionTypes.find(el => el['name'] === this.RETAIL_TRANS_TYPE)
        this.vinLookup = inventoryItem['stockNumber']

        let odometerStatus = 'actual'
        if (inventoryItem['odometer']) {
            odometerStatus = inventoryItem['odometer'].toLowerCase()
        }

        this.saleVehicle = {
            inventoryId: inventoryItem.id,
            inventory: inventoryItem,
            saleVehicleTransactionTypeId: vehicleTransType && vehicleTransType.id > 0 ? vehicleTransType.id : 0,
            mileage: inventoryItem.miles,
            odometerStatus: odometerStatus,
            sellingPrice: inventoryItem.sellingPrice
        }

        this.formRetailVehicle.get('mileage').setValue(formatCount(this.saleVehicle['mileage']), {emitEvent: false})
        this.formRetailVehicle.get('odometerStatus').setValue(odometerStatus, {emitEvent: false})
        
        this.save()
    }

    /**
     * Assign the inventory id for us in the modal
     */
    public edit = (id: number) => {
        this.inventoryId = id
    }

    public proceedWithDiscard = () => {
        if (!this.saleVehicle || !this.saleVehicle.id || (this.saleVehicle.id <= 0)) {
            return
        }

        this.discardSaleVehicle()
    }

    /**
     * Remove an item from saleVehicles
     */
    private discardSaleVehicle = async () => {
        if (!this.saleVehicle || !this.saleVehicle.id || (this.saleVehicle.id <= 0)) {
            return
        }

        return await this.master.discard(`sales/${this.saleId}/vehicles/${this.saleVehicle.id}`, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] })

            const payload = {
                id: 0,
                inventoryId: 0,
                year: null, 
                make: null, 
                model: null, 
                miles: 0, 
                price: 0
            }

            this.ms.channelComponents$.emit({message: 'vehicleDiscarded', section: 'stock', value: payload})
            this.saleVehicle = null
            this.vinLookup = ''
        })
    }

    /**
     * Acquire the inventory data from the store
     * @param { Number } inventoryId The id of the selected inventory item.
     */
    private fetchInventoryItem = async (inventoryId: number): Promise<Inventory> => {
        if (!inventoryId || inventoryId <= 0) return

        this.loading = true
        return await this.master.getAsync(`inventory/${inventoryId}`).then((res) => {
            this.loading = false
            if (!res || !res.data) {
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            return res.data.inventory
        })
    }

    /**
     * Acquire a list of past purchases for the selected buyer
     */
    private fetchBuyerPastPurchases = async () => {
        if (!this.saleId || (this.saleId <= 0)) {
            return
        }

        if (!this.buyerId || (this.buyerId <= 0)) {
            return
        }

        if (this.purchases) {
            this.purchases.length = 0
        }
        
        this.purchases = []

        await this.master.getAsync(`sales/${this.saleId}/buyers/${this.buyerId}/purchases`).then(res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            let pastPurchases = res.data.tradeins
            if (!pastPurchases || pastPurchases.length <= 0) {
                return
            }

            for (let purchase of pastPurchases) {
                const sale = purchase['sale']
                if (!sale) {
                    continue
                }

                const vehicles = sale['saleVehicles']
                if (!vehicles || (vehicles.length <= 0)) {
                    continue
                }

                const vehicle = vehicles[0]
                if (!vehicle || !vehicle.inventory || !vehicle.inventory.id) {
                    continue
                }

                this.purchases.push({
                    id: parseInt(vehicle.inventory.id),
                    saleId: 0,
                    saleDate: null,
                    stock: vehicle.inventory.stockNumber,
                    stockNumber: vehicle.inventory.stockNumber,
                    vin: vehicle.inventory.vehicle.vinNumber,
                    year: parseInt(vehicle.inventory.vehicle.modelYear),
                    make: vehicle.inventory.vehicle.make,
                    model: vehicle.inventory.vehicle.model,
                    vehicleInfo: null
                })
            }
        })
    }
    
    /**
     * A saleCreated event from parent, assign saleId and
     * save the vehicle, if one is selected
     * @param { number } saleId The id of the sale from the parent.
     */
    public saleCreated = (saleId: number): void => {
        if (saleId <= 0) {
            return
        }

        if (this.saleId != saleId) {
            this.saleId = saleId
            if (this.saleVehicle && Object.keys(this.saleVehicle).length > 0) {
                this.save()
            }
        }
    }
    
    /**
     * If header Quote Status changed, update vehicle inventory status.
     * @param { number } stageId The id of the stage from the parent.
     */
    public saleStageChanged = (stageId): void => {
        if (!this.saleVehicle) {
            return
        }
    }

    /**
     * Map db compatible object to post.
     * @param { number } vehicleId The id of the vehicle.
     * @param { number } transactionTypeId The id of the transactionType (Retail or Trade-In).
     */
    private mapVehicle = async (vehicleId, transactionTypeId) => {
        return {
            lotId: this.lotId,
            saleVehicleTransactionTypeId: transactionTypeId,
            inventoryId: this.saleVehicle['inventoryId'] || 0,
            vehicleId: vehicleId,
            mileage: clean(this.formControlRetailVehicle.mileage.value),
            odometerStatus: (this.formControlRetailVehicle.odometerStatus.value || 'actual').toLowerCase(),
            sellingPrice: this.saleVehicle['sellingPrice'] || this.saleVehicle.inventory.sellingPrice || 0,
            lienholderContactId: null,
            saleStageId: this.saleVehicle['saleStageId'],

            //trade-in data
            saleIdTradedOn: null,
            saleIdTradedFrom: null,
            tradeInAllowance: 0,
            tradeInPayoff: 0
        }
    }

    /**
     * Save the selected vehicle to the store
     */
    public save = async () => {
        if (this.saving) {
            return
        }

        if (!this.saleId || (this.saleId <= 0)) {
            const payload = {
                id: 0, 
                inventoryId: 0,
                year: null, 
                make: null, 
                model: null, 
                miles: 0, 
                price: 0
            }

            this.ms.channelComponents$.emit({message: 'vehicleInit', section: 'stock', value: payload})
            return
        }

        if (!this.saleVehicle) {
            return
        }

        let saleVehicleTransactionTypeId = this.saleVehicle['saleVehicleTransactionTypeId'] ? parseInt(this.saleVehicle['saleVehicleTransactionTypeId']) : 0
        if (isNaN(saleVehicleTransactionTypeId) || (saleVehicleTransactionTypeId <= 0)) {
            return
        }

        let payload = await this.mapVehicle(this.saleVehicle['inventoryId'], saleVehicleTransactionTypeId)

        const identity = parseInt(this.saleVehicle['id'])
        if (!identity || isNaN(identity) || (identity <= 0)) {
            this.add(payload)
            return
        }

        this.modify(identity, payload)
    }

    /**
     * Create the new retail sale vehicle
     * @param vehicle 
     */
    private add = (vehicle) => {
        if (!this.saleId || this.saleId <= 0) {
            return
        }

        if (!vehicle) {
            return
        }

        this.saving = true
        this.master.post(`sales/${this.saleId}/vehicles`, { payload: vehicle }, (res) => {
            this.saving = false

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
            }

            this.saleVehicle['id'] = res.data.id

            const payload = {
                id: this.saleVehicle.id,
                inventoryId: this.saleVehicleId,
                year: this.saleVehicle.inventory.vehicle.modelYear,
                make: this.saleVehicle.inventory.vehicle.make,
                model: this.saleVehicle.inventory.vehicle.model,
                miles: this.saleVehicle.mileage,
                price: this.saleVehicle.inventory.sellingPrice
            }

            this.ms.channelComponents$.emit({message: 'vehicleAdded', section: 'stock', value: payload})
        })
    }

    /**
     * Modify the existing retail sale vehicle.
     * @param id 
     * @param vehicle 
     * @returns 
     */
    private modify = (id:number, vehicle: Object) => {
        if (!this.saleId || this.saleId <= 0) {
            return
        }

        if (!id || (id <= 0)) {
            return
        }

        if (!vehicle) {
            return
        }

        this.saving = true
        this.master.put(`sales/${this.saleId}/vehicles/${id}`, { payload: vehicle }, (res) => {
            this.saving = false

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
            }

            const payload = {
                id: this.saleVehicle.id,
                inventoryId: this.saleVehicleId,
                year: this.saleVehicle.inventory.vehicle.modelYear,
                make: this.saleVehicle.inventory.vehicle.make,
                model: this.saleVehicle.inventory.vehicle.model,
                miles: this.saleVehicle.mileage,
                price: this.saleVehicle.inventory.sellingPrice
            }

            this.ms.channelComponents$.emit({message: 'vehicleChanged', section: 'stock', value: payload})
        })
    }

    /**
     * Handle open button clicks in the inventory list modal.
     * @param e 
     */
    public listOpened = (e): void => {
        e.stopPropagation()
        this.displayList = true

        const btn = (document.getElementById('btn-choose-retail') as HTMLButtonElement)
        if (!btn) {
            return
        }

        btn.click()
    }

    /**
     * Handle open button clicks in the inventory list modal.
     * @param e 
     */
    public detailOpened = (e): void => {
        e.stopPropagation()

        const btn = (document.getElementById('btn-view-detail') as HTMLButtonElement)
        if (!btn) {
            return
        }

        btn.click()
    }

    /**
     * Handle close button clicks in the inventory list modal.
     * @param e 
     */
    public listClosed = (e): void => {
        this.displayList = false
    }

    /**
     * Close the inventory list modal after tbe user selects a vehicle.
     * @returns 
     */
    private closeChooser = (): void => {
        this.displayList = false
        const btn: HTMLButtonElement = (document.getElementById('btn-choose-retail') as HTMLButtonElement)
        if (!btn) {
            return
        }

        btn.click()
    }

    /**
     * When the user leaves (blur) the mileage input 
     * ensure we format the value.
     * @param {Event} e The blur event that triggerd the reformat
     */
    protected blurred = (e: Event): void => {
        if (!e || !e.target) {
            return
        }

        const input = (e.target as HTMLInputElement)
        if (!input) {
            return
        }

        let amount = clean(input.value)
        if (!amount || isNaN(amount)) {
            amount = 0
        }

        input.value = formatCount(amount)
        this.formRetailVehicle.get('mileage').setValue(input.value)
    }   

}
